import { render, staticRenderFns } from "./SampleRequestCard.vue?vue&type=template&id=5cb42679&"
import script from "./SampleRequestCard.vue?vue&type=script&lang=js&"
export * from "./SampleRequestCard.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequestCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports